import React from 'react'
import { Link } from 'react-router-dom'
import { TabletAndLarger } from '../../shared/responsive-breakpoints'

const HomeAccount = ({ accountData }) => {
  const { buttonText, details, header, image } = accountData
  return (
    <section className="dealmed-home-account" aria-labelledby="dealmed-home-account-heading">
      <div className="dealmed-container">
        <div className="dealmed-home-account__content">
          <div className="dealmed-container">
            <h2 className="dealmed-home-account__heading" id="dealmed-home-account-heading">
              {header}
            </h2>
            <p className="dealmed-home-account__text">{details}</p>
            <Link to="/register" className="dealmed-home-account__link">
              {buttonText}
            </Link>
          </div>
        </div>
        <TabletAndLarger>
          <img
            src={image.fields.file.url}
            className="dealmed-home-account__image"
            alt=""
            loading="lazy"
          />
        </TabletAndLarger>
      </div>
    </section>
  )
}

export default HomeAccount
